// react
import React, { useState } from 'react';

// third-party
import classNames from 'classnames';
import PropTypes from 'prop-types';

// application
import AppLink from '../shared/AppLink';
import { ArrowRoundedRight6x9Svg } from '../../svg';

function Menu(props) {
    const {
        layout,
        withIcons,
        items,
        onClick,
    } = props;
    const [openIndex, setOpenIndex] = useState(null);

    const renderLink = (item, content, index) => {
        let link;

        if (item.url) {
            link = (
                <AppLink
                    {...item.props}
                    to={item.url}
                    onClick={(event) => {
                        if (item.submenu && item.submenu.length) {
                            event.preventDefault();
                            setOpenIndex(openIndex === index ? null : index);
                        } else {
                            onClick(item);
                        }
                    }}
                    aria-expanded={item.submenu && item.submenu.length ? openIndex === index : undefined}
                >
                    {content}
                </AppLink>
            );
        } else {
            link = (
                <button type="button" aria-expanded={item.submenu && item.submenu.length ? openIndex === index : undefined} onClick={() => {
                    if (item.submenu && item.submenu.length) {
                        setOpenIndex(openIndex === index ? null : index);
                    } else {
                        onClick(item);
                    }
                }}>{content}</button>
            );
        }

        return link;
    };

    const itemsList = items.map((item, index) => {
        let arrow;
        let submenu;
        let icon;

        if (item.submenu && item.submenu.length) {
            arrow = <ArrowRoundedRight6x9Svg className="menu__arrow" />;
        }

        if (item.submenu && item.submenu.length) {
            submenu = (
                <div className="menu__submenu">
                    <Menu items={item.submenu} onClick={onClick} />
                </div>
            );
        }

        if (withIcons && item.icon) {
            icon = (
                <div className="menu__icon">
                    <img src={item.icon} srcSet={item.icon_srcset} alt="" />
                </div>
            );
        }

        return (
            <li key={index} className={openIndex === index ? 'menu__item--open' : ''}>
                {renderLink(item, (
                    <React.Fragment>
                        {icon}
                        {item.title}
                        {arrow}
                    </React.Fragment>
                ), index)}
                {submenu}
            </li>
        );
    });

    const classes = classNames(`menu menu--layout--${layout}`, {
        'menu--with-icons': withIcons,
    });

    return (
        <ul className={classes}>
            {itemsList}
        </ul>
    );
}

Menu.propTypes = {
    /** one of ['classic', 'topbar'] (default: 'classic') */
    layout: PropTypes.oneOf(['classic', 'topbar']),
    /** default: false */
    withIcons: PropTypes.bool,
    /** array of menu items */
    items: PropTypes.array,
    /** callback function that is called when the item is clicked */
    onClick: PropTypes.func,
};

Menu.defaultProps = {
    layout: 'classic',
    withIcons: false,
    items: [],
    onClick: () => {},
};

export default Menu;
